/** Fields of a processing view that its duration is derived from. */
export interface ProcessingDurationSource {
  status: string;
  started?: string | null;
  durationSeconds?: number | null;
}

const RUNNING_STATUSES: ReadonlySet<string> = new Set<string>(['InProgress', 'Optimization']);

/**
 * Milliseconds a processing took, or has been running so far; null when it has not started or its
 * duration is unknown.
 */
export function getProcessingDurationMs(processing: ProcessingDurationSource, nowMs: number): number | null {
  if (processing.durationSeconds !== undefined && processing.durationSeconds !== null) {
    return processing.durationSeconds * 1000;
  }
  const started: string | null | undefined = processing.started;
  if (
    !RUNNING_STATUSES.has(processing.status) ||
    started === undefined ||
    started === null ||
    started.startsWith('0001-')
  ) {
    return null;
  }
  const startedMs: number = Date.parse(started);
  return Number.isFinite(startedMs) ? Math.max(0, nowMs - startedMs) : null;
}

/** Compact duration such as "45 s", "12 min 3 s" or "1 h 2 min". */
export function formatProcessingDuration(milliseconds: number | null): string {
  if (milliseconds === null) {
    return '—';
  }
  const seconds: number = Math.round(milliseconds / 1000);
  if (seconds < 1) {
    return '< 1 s';
  }
  if (seconds < 60) {
    return `${seconds} s`;
  }
  const minutes: number = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes} min ${seconds % 60} s`;
  }
  return `${Math.floor(minutes / 60)} h ${minutes % 60} min`;
}
